import { createBulkMutationHook, createDefaultMutationHook } from "hooks/useMutationHandler";

import { RUN_CONFIRM } from "./gql";

const useConfirmRun = createDefaultMutationHook(RUN_CONFIRM);
export const useBulkConfirmRun = createBulkMutationHook(RUN_CONFIRM);

export default useConfirmRun;
